import { Component, EventEmitter, Output } from '@angular/core';

import { StateService } from '../../services/state.service';

@Component({
  selector: 'hcf-filter-help-form',
  templateUrl: './filter-help-form.component.html',
  styleUrls: ['./filter-help-form.component.scss'],
  standalone: false,
})
export class FilterHelpFormComponent {
  @Output() closePopupHandler = new EventEmitter();

  constructor(private _stateService: StateService) {}

  done() {
    this._stateService.closePopup();
  }
}
